import { Column, Table, Button } from '@cb/apricot-react';
import { FC } from 'react';

import { TDISchool, IDISearchRecord } from 'src/di/types';
import { SubTitle } from 'src/generic/component';
import { APP_URLS } from 'src/constants';
import { useNavigate } from 'react-router-dom';

interface DISearchResultProps {
  dischools: IDISearchRecord[];
  searchParams: object;
}

const DISearchResult: FC<DISearchResultProps> = ({ dischools, searchParams }) => {
  const navigate = useNavigate();

  const isInternationalSchool = (dischool: TDISchool): boolean => {
    return dischool.orgCountryCode !== 'US' && dischool.orgCountryCode !== '';
  };

  return <Table
      a11yHighlightType="append"
      sortType="inline"
      className="header-aligned-table"
      data={dischools}
      tableId="diSearchResult">
      <Column field="" rowHeader title=""
        onValueFormat={(_value, record: any, rowIndex) => {
          const data = record.di;
          const activeRequest = record.active;
          const ownedRequest = record.owned;
          if (!activeRequest) {
            return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Button onClick={() => {
                navigate(APP_URLS.DIUPDATEFORM, {
                  state:
                  {
                    data: data,
                    source: 'SEARCH',
                    search: searchParams
                  }
                });
              }}>Update</Button>
            </div>;
          } else if (activeRequest && ownedRequest) {
            return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Button onClick={() => {
                navigate(APP_URLS.DIUPDATEFORM, {
                  state: {
                    summary: ownedRequest,
                    source: 'SEARCH',
                    search: searchParams
                  }
                });
              }}>Update Requested</Button>
            </div>;
          } else if (activeRequest && !ownedRequest) {
            return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Button disabled={true}>Request Processing</Button>
            </div>;
          } else {
            return <span style={{ color: 'red' }}>Update Unavailable</span>;
          }
        }} />
      <Column field="di.diCode" sortable title="Score Send Code" onValueFormat={(_value, record: any) => {
        const data = record.di;
        return <>
          <div>
            <strong>Score Send Code:</strong> {data.diCode}
          </div>
          <br />
          <div style={{ marginBottom: '8px' }}>
            <SubTitle>Programs</SubTitle>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: '50px' }}>
            <div>
              SAT Accepted:  {data.diSatPgmInd || "N"}<br />
              AP  Accepted:  {data.diApPgmInd || "N"}<br />
              {/* CLEP  Accepted:  {data.diClepApPgmInd || "N"} */}
            </div>
          </div>
        </>;
      }} />
      <Column
        field="di.orgNameAddress"
        sortable
        title="Organization Name And Visiting Address"
        onValueFormat={(_value, record: any) => {
          const data = record.di;
          return <>
            <div>
              <strong>Name:</strong> {data.orgName}
            </div>
            <div>
              <strong>Address:</strong> {data.orgAddress}
            </div>
            <div>
              <strong>City:</strong> {data.orgCity}
            </div>
            {isInternationalSchool(data) && (
              <div>
                <strong>Province:</strong> {data.orgProvince}
              </div>
            )}
            {isInternationalSchool(data) && (
              <div>
                <strong>Postal Code:</strong> {data.orgPostalCode}
              </div>
            )}
            {!isInternationalSchool(data) && (
              <div>
                <strong>State:</strong> {data.orgStateCode}
              </div>
            )}
            {!isInternationalSchool(data) && (
              <div>
                <strong>Zip:</strong> {data.orgZip}
              </div>
            )}
          </>;
        }}
      />
    </Table>
};

export default DISearchResult;
